import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ISaleOrder } from 'src/app/modules/sales-order-management/models/sale-order.interface';

interface IPnlSummaryItem {
    label: string;
    value: string | number;
}

@Component({
    selector: 'eci-consolidate-shipments-pnl',
    templateUrl: './consolidate-shipments-pnl.component.html',
    styleUrls: ['./consolidate-shipments-pnl.component.scss']
})
export class ConsolidateShipmentsPnlComponent implements OnInit, OnChanges {

    @Input() saleOrders: ISaleOrder[] = [];

    displayedColumns: string[] = [
        'orderId',
        'destination',
        'carrier',
        'trackingNumber',
        'chargeableWeight',
        'lastMileCost',
        'lastMileAddCharges',
        'dtw',
        'totalDtdCost',
        'price',
        'profit',
    ];

    dataSource: MatTableDataSource<ISaleOrder> = new MatTableDataSource<ISaleOrder>([]);
    summaryItems: IPnlSummaryItem[] = [];

    ngOnInit(): void {
        this.applyDataSource();
        this.buildSummaryItems();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.saleOrders) {
            this.applyDataSource();
            this.buildSummaryItems();
        }
    }

    getDestination(order: ISaleOrder): string {
        const shippingAddress = order?.marketplace?.buyer?.shippingAddress;
        if (shippingAddress?.state?.country?.name) {
            return shippingAddress.state.country.name;
        }
        return shippingAddress?.country?.name || '';
    }

    private applyDataSource(): void {
        this.dataSource = new MatTableDataSource<ISaleOrder>(this.saleOrders || []);
    }

    private buildSummaryItems(): void {
        this.summaryItems = [
            { label: 'SO Qty', value: this.saleOrders?.length || 0 },
            { label: 'Total Last Mile Cost', value: '' },
            { label: 'Total Duty', value: '' },
            { label: 'Average Profit/Order', value: '' },
            { label: 'Total L.M Add.Charges', value: '' },
            { label: 'Total DTD Cost', value: '' },
            { label: 'Total Profit', value: '' },
        ];
    }
}
